var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ix-section',[_c('ix-section-text',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.renderMarkdown(_vm.$t('companyInfo.explanation.text')))}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }